import { getHunters, recount } from "./view/api";
import { setHuntersList } from "../../services/redux/actions/app-actions";

export const getHuntersData = (sale_department_id) => async (
  dispatch,
  getState
) => {
  if (!sale_department_id) return;
  const { huntersList } = getState().appState;
  if (huntersList.id === sale_department_id && !!huntersList.list?.length)
    return;
  try {
    const hunters = await getHunters(sale_department_id);
    dispatch(setHuntersList({ list: hunters || [], id: sale_department_id }));
  } catch (e) {
    dispatch(setHuntersList({ list: [], id: sale_department_id }));
  }
};

export const recountClientChoice = async (crm_deal_id) => {
  try {
    return await recount(crm_deal_id);
  } catch (e) {}
};

export const booleanList = [
  {
    value: true,
    show: "Да",
  },
  {
    value: false,
    show: "Нет",
  },
];
/** UI value for «Все» — must not be null, so empty default stays visually empty. */
export const REMONT_TYPE_ALL = -1;

/** SP sentinel: без типа (NULL) + опциональный (0). Used when filter is empty. */
export const REMONT_TYPE_DEFAULT = -2;

export const remontTypes = [
  { id: REMONT_TYPE_ALL, label: "Все" },
  { id: 0, label: "Опциональный" },
  { id: 1, label: "ДДУ" },
  { id: 2, label: "Маркетинговая продажа(Видовая)" },
  { id: 3, label: "Маркетинговая продажа(Демо этаж)" },
];

const mapRemontTypeFilter = (remontType1c) => {
  // Empty / cleared → без типа + опционалки
  if (remontType1c === null || remontType1c === undefined || remontType1c === "") {
    return REMONT_TYPE_DEFAULT;
  }
  // «Все» → no equality filter on SP (show every type including DDU)
  if (remontType1c === REMONT_TYPE_ALL) {
    return null;
  }
  return remontType1c;
};

export const buildDealsFilterParams = (value, cityId) => ({
  ...value,
  city_id: cityId === "null" || cityId === "" ? null : cityId,
  remont_type_1c: mapRemontTypeFilter(value?.remont_type_1c),
});
